/* eslint no-template-curly-in-string: 0 */
import wholeFoodsIcon from '../../assets/images/wholefoodsLogo.png';
import { PAYMENT_NETWORKS } from "../../utils/enums";

export const wholeFoods = {
  id: PAYMENT_NETWORKS.EGIFT_BLACKHAWK_WHOLEFOODS,
  displayName: "Whole Foods™",
  paywall: {
    tile: {
      displayName: "Whole Foods™",
      tagline: "Premium groceries and supplies",
      logo: wholeFoodsIcon
    },
    disabledPaymentNetwork: {
      title: 'Endpoint Not Live',
      description: 'For this trial program, ${paymentNetwork.displayName} is only listed as an example of the 250+ options DigitalPay currently offers.  Click the button below to go back and select a live network. Live networks are not “grayed out.”'
    },
  },
};

export default wholeFoods;
